export enum ChatSubscribeMessage {
  JOIN_CONVERSATION = "join_conversation",
  SEND_MESSAGE = "send_message",
  TYPING = "typing",
  MESSAGE_READ = "message_read",
  NEW_MESSAGE = "new_message",
  USER_TYPING = "user_typing",
  NEW_CONVERSATION_MESSAGE = "new_conversation_message",
}

export enum MessageType {
  TEXT = "text",
  FILE = "file",
  IMAGE = "image",
}

export enum SenderType {
  PATIENT = "patient",
  DOCTOR = "doctor",
}

export type Attachment = {
  url: string;
  filename: string;
  mimeType: string;
  size: number;
  thumbnail: string;
};

export type ChatMessage = {
  attachments: Attachment[];
  content: string;
  conversationId: string;
  createdAt: Date;
  id: string;
  messageType: MessageType;
  readAt: Date | null;
  senderId: string;
  senderType: SenderType;
  updatedAt: Date;
};

export type ChatMessageResponse = {
  success: boolean;
  message: ChatMessage;
};

export type JoinConversationPayload = {
  conversationId: string;
};

export type JoinConversationResponse = {
  success: boolean;
  conversationId: string;
};

export type SendMessagePayload = {
  conversationId: string;
  content?: string;
  messageType?: MessageType;
  attachments?: {
    url: string;
    filename: string;
    mimeType: string;
    size?: number;
    thumbnail?: string;
  }[];
};

export type TypingResponse = {
  conversationId: string;
  senderId: string;
};

export type TypingPayload = {
  conversationId: string;
};

export type MessageReadPayload = {
  messageId: string;
  readAt: Date;
};

export type NewConversationMessageReponse = {
  conversationId: string;
  senderId: string;
  senderType: SenderType;
  content: string;
  messageType: MessageType;
  readAt: Date | null;
  createdAt: Date;
  updatedAt: Date;
  id: string;
};
